import { createSelector } from '@reduxjs/toolkit';
import { chatWindowSelector } from './chatWindowSelector';

export const currentOpenedChatIdSelector = createSelector(
  [chatWindowSelector],
  chatWindow => chatWindow.currentOpenedChatId,
);
